import React from "react";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Thementor = () => {
  const [theMentor, setTheMentor] = useState([]);

  useEffect(() => {
    fetchTheMentor();
  }, []);

  const fetchTheMentor = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/the-mentors"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data the mentor");
      }
      const data = await response.json();
      setTheMentor(data.data[0] || []);
    } catch (error) {
      setTheMentor([]);
    }
  };

  return (
    <>
    <div className="bg-gray-100">
      <div className="flex overflow-hidden relative flex-col justify-center items-center px-16 py-20 text-center text-white min-h-[677px] max-md:px-5">
        <img
          loading="lazy"
          src={`${process.env.REACT_APP_API_URL}/${theMentor.image}`}
          className="object-cover absolute inset-0 size-full"
          alt={theMentor.image}
        />
        <div className="relative self-center mt-20 mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
          {theMentor.short_title}
        </div>
        <div
          className="relative mt-16 mb-8 text-lg font-normal text-gray-300 leading-7 lg:text-xl sm:px-16 lg:px-48 max-md:mt-10 max-md:mr-1.5 max-md:max-w-full"
          dangerouslySetInnerHTML={{ __html: theMentor.short_description }}
        />
      </div>

      {/* Teks Content 1 */}
      <div className="px-7 pt-6 pb-4 my-5 text-lg leading-7 mr-2 ml-2 text-center text-black max-md:px-5 max-md:max-w-full lg:w-full">
        <div className="grid mobile:grid-flow-row mobile:grid-cols-1 lg:grid-flow-col lg:mt-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="w-10/12 mx-auto">
              <h1 className="font-bold mobile:text-xl lg:text-3xl">
                {theMentor.title}
              </h1>
              <div
                className="mt-10 text-justify text-lg mobile:mb-14"
                dangerouslySetInnerHTML={{ __html: theMentor.description }}
              />
            </div>
          </div>

          <div className="bg-white rounded-2xl py-16 lg:col-span-4">
            <div className="">
              <h1 className="text-2xl font-bold text-center">
                Dokumentasi Kegiatan
              </h1>
            </div>
            {theMentor.documentation_image?.map((documentation_image, index) => (
            <div className="max-w-md mx-auto mt-10 mobile:px-4">
              <img
                loading="lazy"
                src={`${process.env.REACT_APP_API_URL}/${documentation_image}`}
                className="object-cover w-full h-80 max-md:h-auto rounded-xl mobile:h-52"
                alt={`documentation ${index}`}
              />
            </div>
            ))}
          </div>
        </div>
      </div>
      {/* Teks Content 1 end */}
      <FloatingMenu />
      </div>
    </>
  );
};

export default Thementor;
